<!-- 科研成果 成就页面 点击照片调转至该页面 -->
<template>
  <div class="achievementsDetail">
    <div class="card">
      <div class="cardImgDiv">
        <img :src="this.titleImg" alt="封面" class="cardImg" />
      </div>
      <div class="projectName">项目名称：{{ this.detail.siName }}</div>
      <div class="projectOwner">项目负责人：{{ this.detail.siAlumniName }}</div>
      <div class="telDiv clearfix">
        <div class="tel">联系方式：{{ this.detail.siPhone }}</div>
        <div class="telIconDiv">
          <a :href="'tel' + ':' + this.detail.siPhone">
            <img src="../../assets/image/btn_dianhua_nor.png" alt="电话" class="telIcon" />
          </a>
        </div>
      </div>
    </div>
    <div class="title clearfix">
      <div class="icon"></div>
      <div class="titleName">项目简介</div>
    </div>
    <div class="introduction">{{ this.detail.siDescription }}</div>
    <div class="title clearfix">
      <div class="icon"></div>
      <div class="titleName">成果照片</div>
    </div>
    <div class="photoShow clearfix">
      <div class="photo" v-for="item in this.detail.siAchievementImg" :key="item">
        <img :src="item" alt="展示图片" class="photoImg" />
      </div>
    </div>
    <div class="get clearfix">
      <button class="getBtn1" @click="getPdf1">获取概述文件</button>
      <button class="getBtn2" @click="getPdf2">获取成绩文件</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: "",
      titleImg: "",
    };
  },
  created() {
    this.getScienceDetail();
  },
  methods: {
    async getScienceDetail() {
      const result = await this.$http.get("/achievementTransform/AchievementByName", {
        params: { id: this.$route.query.id },
      });
      this.detail = result.data.AchievementByName;
      this.titleImg = this.detail.siAchievementImg[0];
    },
    getPdf1() {
      /* const url = [];
      url.push(this.detail.desc_doc);
      url.push(this.detail.achievement_doc); */
      window.location.href = this.detail.siDescDoc;
      /*  for (let i = 0; i < 2; i++) {
        let aDom = document.createElement("a"); //创建标签
        let evt = document.createEvent("HTMLEvents"); //创建事件
        evt.initEvent("click", false, false); //初始化事件，绑定点击事件，不冒泡，不阻止浏览器默认行为
        aDom.download = url[i];
        aDom.target = "_blank";
        aDom.href = url[i]; //对地址进行编码
        aDom.dispatchEvent(evt); //触发事件
        aDom.click();
      } */
    },
    getPdf2() {
      window.location.href = this.detail.siAchievementDoc;
    },
  },
};
</script>
<style lang="less" scoped>
.achievementsDetail {
  position: relative;
  min-height: 100vh;

  .card {
    position: relative;
    left: 5%;
    width: 90%;
    background: #ffffff;
    border: 1px solid #e1e1e1;
    border-radius: 15px;

    .cardImgDiv {
      position: relative;
      left: 2%;
      width: 96%;
      height: 25vh;
      margin-top: 2vw;

      .cardImg {
        width: 100%;
        height: 100%;
        border-radius: 15px;
      }
    }

    .projectName,
    .projectOwner {
      position: relative;
      left: 3%;
      margin-top: 10px;
      font-weight: bold;
      color: #666666;
    }

    .telDiv {
      position: relative;
      left: 3%;
      margin: 10px 0;

      .tel {
        float: left;
        font-weight: bold;
        color: #666666;
      }

      .telIconDiv {
        float: left;
        width: 12px;
        margin-left: 5px;

        .telIcon {
          width: 100%;
        }
      }
    }
  }

  .introduction {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 15px;
    text-indent: 2em;
    font-weight: 400;
    color: #333333;
    line-height: 2em;
    word-wrap: break-word;
    word-break: break-all;
  }

  .photoShow {
    position: relative;
    left: 5%;
    width: 90%;
    margin-top: 15px;

    .photo {
      float: left;
      width: 45%;
      height: 14vh;
      margin: 0 2.5% 10px 2.5%;

      .photoImg {
        height: 100%;
        width: 100%;
        border-radius: 15px;
      }
    }
  }

  .get {
    position: relative;
    left: 5%;
    top: 15px;
    width: 90%;
    bottom: 15px;

    .getBtn1 {
      float: left;
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 48%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }

    .getBtn2 {
      float: right;
      border: 0;
      background: linear-gradient(270deg, #00706E, #00706E);
      color: white;
      width: 48%;
      padding: 10px 0;
      font-size: 1.2rem;
      font-weight: bold;
    }
  }
}

.title {
  position: relative;
  left: 5%;
  margin-top: 10px;

  .icon {
    float: left;
    height: 5vw;
    width: 3px;
    background: #00706E;
    border-radius: 3px;
  }

  .titleName {
    float: left;
    margin-left: 5px;
    font-size: 1.1rem;
    font-weight: bold;
    color: #333333;
  }
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/achievements/AchievementsDetail.vue